import { combineReducers } from 'redux-immutable';
import { RESET_STATE } from '../actions/actionTypes';
import decision from './decision';
import summaryOutcomes from './summaryOutcomes';
import outcomeValues from './outcomeValues';

const applicationReducer = combineReducers({
  decision,
  summaryOutcomes,
  outcomeValues,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    state = undefined;
  }
  return applicationReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/state/reducers/root.js